export const holidayEN = {
    "holidaySider": {
        "headingLabel": "Setup Holiday",
        "information": "Infor Holiday",
        "listHoliday": "List Holiday"
    },
    "holidayTitle": {
        "dayOff": "Day Off",
        "type": "Type Holiday",
        "reason": "Reason",
        "isTimeKeeping": "Is Time Keeping",
        "repeat": "Repeat",
        "startTime": "Start Time",
        "endTime": "End Time",
        "department": "Department",
        "position": "Position",
        "ceator": "Ceator"
    },
    "holidayMenu": {
        "addHoliday": "Add Holiday",
        "editHoliday": "Update Holiday",
        "deleteHoliday": "Delete Holiday"
    },
    "holidayType": {
        "0": "Holiday",
        "1": "Compensatory leave, Event break",
        "2": "Unusual leave"
    },
    "tabHoliday": {
        "type0": "Holiday",
        "type1": "Compensatory leave, Event break",
        "type2": "Unusual leave"
    },
    "holidayPalacehodel": {
        "reason": "Import Reason",
        "type": "Select Type",
        "department": "All",
        "position": "All",
        "yes" : "Yes",
        "no" : "No"
    },
    "holidayRequired": {
        "reason": "Please PImport Reason!",
        "type": "Please Select Type!",
        "department": "Please Select Department!",
        "position": "Please Select Position!",
        "dayOff": "Please Select Day Off!",
        "isTimeKeeping": "Please Select Is Time Keeping!"
    }
}